import React from 'react';
import ReactDOM from 'react-dom/client';
//import posthog from 'posthog-js';
import KDSMonitor from './App.js';
import NamespaceSelector from './components/NamespaceSelector.js';
import {getNamespaceFromUrl, isRootPage} from './services/service.js';
import './styles/globals.css';

// posthog.init('phc_cZyENAslEHTUNXMWgnXbTwdYEGPrET1EXkbmya8Jw7r', {
//   api_host: 'https://app.posthog.com',
//   loaded: (posthog) => {
//     //if (process.env.NODE_ENV === 'development') posthog.debug();
//   }
// });

const root = ReactDOM.createRoot(document.getElementById('root'));

function App() {
  const currentNamespace = getNamespaceFromUrl();
  const isRoot = isRootPage();
  return isRoot || !currentNamespace
    ? <NamespaceSelector />
    : <KDSMonitor />;
}

root.render(
  <App />
);